import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../redux/actions';
import * as pluginActions from '../../plugin/redux/actions';
import { EditorState } from 'draft-js';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import ParentDocCard from '../../common/ParentDocCard';
import { TemplateHeaderNav } from '../TemplateHeaderNav';
import { TYPESENSE_SEARCH_TEMPLATE } from 'drapcode-constant';
import TypesenseSearchTemplateForm from './TypesenseSearchTemplateForm.js';
import { isProjectReadOnly } from '../../../common/utils/api_utils.js';

export class TypesenseSearchTemplate extends Component {
  static propTypes = {
    template: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  toggle = (activeTab) => {
    this.setState({ activeTab: activeTab });
  };
  static propTypes = {
    template: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    editorState: EditorState.createEmpty(),
    name: '',
    subject: '',
    collectionId: '',
    selectedCollectionFields: [],
  };

  componentDidMount = () => {
    const { match, actions, pluginActions } = this.props;
    const { projectId, version } = match.params;
    actions.loadCollections({ projectId, version });
    pluginActions.loadAllInstalledPlugin({ projectId, version });
  };

  handleSubmit = (values) => {
    const { projectId, version } = this.props.match.params;
    values.projectId = projectId;
    let args = {
      projectId,
      version,
      values: values,
    };
    this.props.actions.createTypesenseSearchTemplate(args).then(() => {
      this.toggle(TYPESENSE_SEARCH_TEMPLATE);
    });
  };
  toggle = (activeTab) => {
    const { projectId, version } = this.props.match.params;
    this.props.history.push({
      pathname: `/template/${version}/v/${projectId}`,
      state: { activeTab: activeTab },
    });
  };

  render() {
    const { template, plugin, match } = this.props;
    const { editorState, name, collectionId, selectedCollectionFields, subject } = this.state;
    const { collections, createTypesenseSearchTemplatePending } = template;
    const { installedPlugins } = plugin;
    const { projectId } = match.params;
    const isReadOnly = isProjectReadOnly(projectId);
    return (
      <div className="main">
        <div className="section">
          <div className="container">
            <TemplateHeaderNav
              activeTab={TYPESENSE_SEARCH_TEMPLATE}
              title={'Typesense Search Templates'}
              toggle={this.toggle}
              installedPlugins={installedPlugins}
            />
            <div className="row mx-auto">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                <div className="card">
                  <div
                    className="card-header card-header-icon"
                    data-background-color="drapcode-dark-blue"
                  >
                    <i className={`wb ${drapcodeIcon(TYPESENSE_SEARCH_TEMPLATE)}`}></i>
                  </div>
                  <div className="card-content">
                    <TypesenseSearchTemplateForm
                      handleSubmit={this.handleSubmit}
                      editorState={editorState}
                      name={name}
                      subject={subject}
                      collectionId={collectionId}
                      collections={collections}
                      selectedCollectionFields={selectedCollectionFields}
                      createTypesenseSearchTemplatePending={createTypesenseSearchTemplatePending}
                      isReadOnly={isReadOnly}
                    />
                  </div>
                </div>
              </div>
              <ParentDocCard>
                <h5>
                  <b>Typesense Search Template</b>
                </h5>
                <p>
                  You can create custom Typesense Search Template and use them to display typesense
                  search results your way.
                </p>
                <br />
              </ParentDocCard>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    template: state.template,
    plugin: state.plugin,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    pluginActions: bindActionCreators({ ...pluginActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TypesenseSearchTemplate);
